import React from "react";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

interface PageLogoutButtonProps {
  className?: string;
}

const PageLogoutButton: React.FC<PageLogoutButtonProps> = ({ className = "" }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/", { replace: true });
  };

  return (
    <Button
      type="default"
      danger
      size="small"
      className={`text-xs font-medium ${className}`}
      onClick={handleLogout}
    >
      Logout
    </Button>
  );
};

export default PageLogoutButton;
